export enum CleanCleanerRole {
  CLEANER = 'CLEANER',
  CLEANER_LIMITED = 'CLEANER_LIMITED',
  MANAGER = 'MANAGER'
}

export type CleanCleanerRoleValue = `${CleanCleanerRole}`

/**
 * 清掃スタッフ (アクセス範囲の物件・担当予定だけを扱う) ロールかどうか.
 * CLEANER_LIMITED は CLEANER と同じ権限を持つため, 権限チェックで同様に扱う.
 */
export const isCleanerRole = (role: CleanCleanerRoleValue) => {
  const cleanerRole = role as CleanCleanerRole
  switch (cleanerRole) {
    case CleanCleanerRole.CLEANER:
    case CleanCleanerRole.CLEANER_LIMITED:
      return true
    case CleanCleanerRole.MANAGER:
      return false
    default: {
      const _exhaustive: never = cleanerRole
      throw new Error(`Unknown cleaner role: ${_exhaustive}`)
    }
  }
}
